import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <Helmet>
        <title>Page not found | Fordje</title>
        <meta name="description" content="The page you were looking for could not be found." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <main className="text-center max-w-md">
        <p className="text-sm font-semibold tracking-widest text-fordje-blue-dark mb-3">404</p>
        <h1 className="text-3xl font-bold text-fordje-navy mb-4">Page not found</h1>
        <p className="text-fordje-navy-light mb-8">
          The page you were looking for doesn&apos;t exist or has moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-md bg-fordje-navy px-6 py-3 text-white font-medium hover:bg-fordje-navy-dark transition-colors"
        >
          Go to the Fordje homepage
        </Link>
      </main>
    </div>
  );
};

export default NotFound;
